var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSupportMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,16h-1c0-7.7197266-6.2802734-14-14-14S10,8.2802734,10,16H9c-3.859375,0-7,3.140625-7,7v2c0,3.859375,3.140625,7,7,7 c1.6542969,0,3-1.3457031,3-3V16c0-6.6171875,5.3828125-12,12-12s12,5.3828125,12,12v16c0,4.4111328-3.5888672,8-8,8h-0.1419678 C27.4109497,38.27948,25.8587036,37,24,37c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4c1.8587036,0,3.4109497-1.27948,3.8580322-3 H28c5.5136719,0,10-4.4863281,10-10h1c3.859375,0,7-3.140625,7-7v-2C46,19.140625,42.859375,16,39,16z M10,29 c0,0.5517578-0.4482422,1-1,1c-2.7568359,0-5-2.2431641-5-5v-2c0-2.7568359,2.2431641-5,5-5h1V29z M24,43 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,43,24,43z M44,25c0,2.7568359-2.2431641,5-5,5h-1V18h1 c2.7568359,0,5,2.2431641,5,5V25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSupportMedium);
export default __webpack_public_path__ + "static/media/account-support--medium.478926f90056bb5710e7aea33d6854c1.svg";
export { ForwardRef as ReactComponent };